import React, { useState } from "react";

type StepperProps = {
  min?: number;
  max?: number;
  initial?: number;
  onChange?: (value: number) => void;
};

const Stepper: React.FC<StepperProps> = ({
  min = 0,
  max = Infinity,
  initial = 0,
  onChange,
}) => {
  const [count, setCount] = useState(initial);

  const decrement = () => {
    const newValue = Math.max(count - 1, min);
    setCount(newValue);
    onChange?.(newValue);
  };

  const increment = () => {
    const newValue = Math.min(count + 1, max);
    setCount(newValue);
    onChange?.(newValue);
  };

  return (
    <div className="flex items-center space-x-1">
      <button
        onClick={decrement}
        disabled={count <= min}
        className={`w-6 h-6 font-thin flex items-center justify-center rounded-[5px] text-white text-xl 
          ${
            count <= min
              ? "bg-grey-blue-300 cursor-not-allowed"
              : "bg-blue-medium "
          }`}
      >
        –
      </button>
      <span className="text-[14px] w-4 text-center">{count}</span>
      <button
        onClick={increment}
        disabled={count >= max}
        className={`w-6 h-6 flex font-thin items-center justify-center rounded-[5px] text-white text-xl 
          ${
            count >= max
              ? "bg-grey-blue-300 cursor-not-allowed"
              : "bg-blue-medium "
          }`}
      >
        +
      </button>
    </div>
  );
};

export default Stepper;
